var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209,
    height: 209,
    viewBox: "0 0 209 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18620",
    "data-name": "Rectangle 18620",
    width: 115,
    height: 75.538,
    fill: "#0050ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23587",
    "data-name": "Group 23587",
    transform: "translate(-314 -1610)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23579",
    "data-name": "Group 23579",
    transform: "translate(248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INC_Cloud_1",
    transform: "translate(-1021 -51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_943",
    "data-name": "Ellipse 943",
    transform: "translate(1087 1661)",
    fill: "#fff",
    stroke: "#0050ad",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 104.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 97,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_49984",
    "data-name": "Path 49984",
    d: "M-6240.577-104.6l-52.09,24.6s-1.1-13.266-5.057-13.953S-6240.577-104.6-6240.577-104.6Z",
    transform: "translate(6455.177 1897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23583",
    "data-name": "Group 23583",
    transform: "translate(113 1677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23583-2",
    "data-name": "Group 23583",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49998",
    "data-name": "Path 49998",
    d: "M115,44.6c-.493,1.078-.908,2.2-1.494,3.224-2.242,3.927-5.777,5.949-10.144,6.626a24.712,24.712,0,0,1-3.8.266q-42.068.022-84.134.015c-3.863,0-7.526-.664-10.678-3.085A13.259,13.259,0,0,1,.095,44.677c-.272-.917.04-1.276.948-1.241.262.009.524,0,.785,0q55.659,0,111.317.012A13.3,13.3,0,0,1,115,43.7ZM48.978,50.978H65.932V47.159H48.978Z",
    transform: "translate(0 20.808)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49999",
    "data-name": "Path 49999",
    d: "M54.286,0h44.04c2.69,0,3.361.679,3.361,3.4q0,26.681,0,53.364c0,2.63-.71,3.356-3.306,3.356q-44.151,0-88.3,0c-2.594,0-3.3-.728-3.3-3.358q0-26.739,0-53.477C6.773.721,7.485,0,10.023,0Q32.154,0,54.286,0M15.115,51.8h78.21V8.326H15.115Z",
    transform: "translate(3.245 -0.001)",
    fill: "#0050ad"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.529a85dd4bdba9155b68d22d39cffce2.svg";
export { ForwardRef as ReactComponent };